import Papa from 'papaparse';
export const isCsvSource = item => item.type === 'Attachment' && /\.csv$/i.test(item.title || item.name || item.path || '');
export function parseCsvSource(value, structured = false) {
  const result = Papa.parse(value.replace(/^\uFEFF/, ''), { skipEmptyLines: 'greedy' });
  if (result.errors.some(error => error.type === 'Quotes')) throw new Error('This CSV could not be read. Check its quotation marks and try again.');
  const [headers, ...rows] = result.data;
  if (!headers?.length || !rows.length) throw new Error('This CSV has no data rows.');
  const text = rows.map((row, index) => `Row ${index + 1}\n` + row.map((cell, column) => `${headers[column] || `Column ${column + 1}`}: ${cell}`).join('\n')).join('\n\n');
  if (text.length > 100000) throw new Error('This CSV is too large for a report. Split it into smaller files.');
  return structured ? { text, headers, rows } : text;
}
export async function loadCsvSource(item, retrieveFile, structured = false) {
  const file = await retrieveFile(item.path, item.title || item.name);
  if (file.size > 15 * 1024 * 1024) throw new Error('This CSV exceeds the 15 MB file limit.');
  return parseCsvSource(await file.text(), structured);
}
